module.exports = __webpack_public_path__ + "scaglie-su-nastro-nw.jpg?0d754c17832af56e453c1d67a79d7a84";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scaglie-su-nastro-nw.jpg
// module id = 250
// module chunks = 0